import LinksPanel from "./LinksPanel";
import GroupPanel from "./GroupPanel";
import MegaMenu from "./MegaMenu";

/** Picks the dropdown panel for a top-level nav item. */
export default function NavDropdown({ item, onNavigate }) {
  const { menu, key } = item;
  if (menu.type === "mega") return <MegaMenu onNavigate={onNavigate} />;
  if (menu.type === "group") return <GroupPanel navKey={key} group={menu.group} onNavigate={onNavigate} />;
  return <LinksPanel navKey={key} menu={menu} onNavigate={onNavigate} />;
}
